/**
 * 判断是否在线
 */

export function isOnline(): boolean {
  return navigator.onLine;
}
